module.exports = [
  { city: `Birmingham`, state: `Alabama`, lat: `33.5274N`, long: `86.7990W` },
  { city: `Huntsville`, state: `Alabama`, lat: `34.7843N`, long: `86.5390W` },
  { city: `Mobile`, state: `Alabama`, lat: `30.6684N`, long: `88.1002W` },
  { city: `Montgomery`, state: `Alabama`, lat: `32.3463N`, long: `86.2686W` },
  { city: `Anchorage`, state: `Alaska`, lat: `61.1775N`, long: `149.2744W` },
  { city: `Chandler`, state: `Arizona`, lat: `33.2829N`, long: `111.8549W` },
  { city: `Gilbert`, state: `Arizona`, lat: `33.3102N`, long: `111.7422W` },
  { city: `Glendale`, state: `Arizona`, lat: `33.5331N`, long: `112.1899W` },
  { city: `Mesa`, state: `Arizona`, lat: `33.4019N`, long: `111.7174W` },
  { city: `Peoria`, state: `Arizona`, lat: `33.7877N`, long: `112.3111W` },
  { city: `Phoenix`, state: `Arizona`, lat: `33.5722N`, long: `112.0880W` },
  { city: `Scottsdale`, state: `Arizona`, lat: `33.6687N`, long: `111.8237W` },
  { city: `Surprise`, state: `Arizona`, lat: `33.6706N`, long: `112.4527W` },
  { city: `Tempe`, state: `Arizona`, lat: `33.3884N`, long: `111.9318W` },
  { city: `Tucson`, state: `Arizona`, lat: `32.1543N`, long: `110.8711W` },
  { city: `Little Rock`, state: `Arkansas`, lat: `34.7254N`, long: `92.3586W` },
  { city: `Anaheim`, state: `California`, lat: `33.8555N`, long: `117.7601W` },
  { city: `Antioch`, state: `California`, lat: `37.9775N`, long: `121.7976W` },
  { city: `Bakersfield`, state: `California`, lat: `35.3212N`, long: `119.0183W` },
  { city: `Berkeley`, state: `California`, lat: `37.8667N`, long: `122.2991W` },
  { city: `Burbank`, state: `California`, lat: `34.1890N`, long: `118.3249W` },
  { city: `Carlsbad`, state: `California`, lat: `33.1239N`, long: `117.2828W` },
  { city: `Chula Vista`, state: `California`, lat: `32.6277N`, long: `117.0152W` },
  { city: `Concord`, state: `California`, lat: `37.9722N`, long: `122.0016W` },
  { city: `Corona`, state: `California`, lat: `33.8624N`, long: `117.5639W` },
  { city: `Costa Mesa`, state: `California`, lat: `33.6659N`, long: `117.9123W` },
  { city: `Daly City`, state: `California`, lat: `37.7009N`, long: `122.4650W` },
  { city: `Downey`, state: `California`, lat: `33.9382N`, long: `118.1309W` },
  { city: `El Cajon`, state: `California`, lat: `32.8017N`, long: `116.9605W` },
  { city: `El Monte`, state: `California`, lat: `34.0746N`, long: `118.0291W` },
  { city: `Elk Grove`, state: `California`, lat: `38.4144N`, long: `121.3849W` },
  { city: `Escondido`, state: `California`, lat: `33.1336N`, long: `117.0732W` },
  { city: `Fairfield`, state: `California`, lat: `38.2568N`, long: `122.0397W` },
  { city: `Fontana`, state: `California`, lat: `34.1088N`, long: `117.4627W` },
  { city: `Fremont`, state: `California`, lat: `37.4944N`, long: `121.9411W` },
  { city: `Fresno`, state: `California`, lat: `36.7827N`, long: `119.7945W` },
  { city: `Fullerton`, state: `California`, lat: `33.8857N`, long: `117.9280W` },
  { city: `Garden Grove`, state: `California`, lat: `33.7788N`, long: `117.9605W` },
  { city: `Glendale`, state: `California`, lat: `34.1814N`, long: `118.2458W` },
  { city: `Hayward`, state: `California`, lat: `37.6281N`, long: `122.1063W` },
  { city: `Huntington Beach`, state: `California`, lat: `33.6906N`, long: `118.0093W` },
  { city: `Inglewood`, state: `California`, lat: `33.9561N`, long: `118.3443W` },
  { city: `Irvine`, state: `California`, lat: `33.6784N`, long: `117.7713W` },
  { city: `Lancaster`, state: `California`, lat: `34.6936N`, long: `118.1753W` },
  { city: `Long Beach`, state: `California`, lat: `33.8091N`, long: `118.1553W` },
  { city: `Los Angeles`, state: `California`, lat: `34.0194N`, long: `118.4108W` },
  { city: `Modesto`, state: `California`, lat: `37.6609N`, long: `120.9891W` },
  { city: `Moreno Valley`, state: `California`, lat: `33.9233N`, long: `117.2057W` },
  { city: `Murrieta`, state: `California`, lat: `33.5719N`, long: `117.1907W` },
  { city: `Norwalk`, state: `California`, lat: `33.9069N`, long: `118.0834W` },
  { city: `Oakland`, state: `California`, lat: `37.7699N`, long: `122.2256W` },
  { city: `Oceanside`, state: `California`, lat: `33.2246N`, long: `117.3062W` },
  { city: `Ontario`, state: `California`, lat: `34.0395N`, long: `117.6088W` },
  { city: `Orange`, state: `California`, lat: `33.8048N`, long: `117.8249W` },
  { city: `Oxnard`, state: `California`, lat: `34.2023N`, long: `119.2046W` },
  { city: `Palmdale`, state: `California`, lat: `34.5913N`, long: `118.1090W` },
  { city: `Pasadena`, state: `California`, lat: `34.1606N`, long: `118.1396W` },
  { city: `Pomona`, state: `California`, lat: `34.0586N`, long: `117.7613W` },
  { city: `Rancho Cucamonga`, state: `California`, lat: `34.1233N`, long: `117.5642W` },
  { city: `Rialto`, state: `California`, lat: `34.1118N`, long: `117.3883W` },
  { city: `Richmond`, state: `California`, lat: `37.9530N`, long: `122.3594W` },
  { city: `Riverside`, state: `California`, lat: `33.9381N`, long: `117.3932W` },
  { city: `Roseville`, state: `California`, lat: `38.7657N`, long: `121.3032W` },
  { city: `Sacramento`, state: `California`, lat: `38.5666N`, long: `121.4686W` },
  { city: `Salinas`, state: `California`, lat: `36.6902N`, long: `121.6337W` },
  { city: `San Bernardino`, state: `California`, lat: `34.1393N`, long: `117.2953W` },
  { city: `San Buenaventura (Ventura)`, state: `California`, lat: `34.2681N`, long: `119.2550W` },
  { city: `San Diego`, state: `California`, lat: `32.8153N`, long: `117.1350W` },
  { city: `San Francisco`, state: `California`, lat: `37.7751N`, long: `122.4193W` },
  { city: `San Jose`, state: `California`, lat: `37.2969N`, long: `121.8193W` },
  { city: `Santa Ana`, state: `California`, lat: `33.7365N`, long: `117.8826W` },
  { city: `Santa Clara`, state: `California`, lat: `37.3646N`, long: `121.9679W` },
  { city: `Santa Clarita`, state: `California`, lat: `34.4049N`, long: `118.5047W` },
  { city: `Santa Maria`, state: `California`, lat: `34.9332N`, long: `120.4438W` },
  { city: `Santa Rosa`, state: `California`, lat: `38.4468N`, long: `122.7061W` },
  { city: `Simi Valley`, state: `California`, lat: `34.2669N`, long: `118.7485W` },
  { city: `Stockton`, state: `California`, lat: `37.9763N`, long: `121.3133W` },
  { city: `Sunnyvale`, state: `California`, lat: `37.3858N`, long: `122.0263W` },
  { city: `Temecula`, state: `California`, lat: `33.5019N`, long: `117.1246W` },
  { city: `Thousand Oaks`, state: `California`, lat: `34.1933N`, long: `118.8742W` },
  { city: `Torrance`, state: `California`, lat: `33.8350N`, long: `118.3414W` },
  { city: `Vallejo`, state: `California`, lat: `38.1079N`, long: `122.2639W` },
  { city: `Victorville`, state: `California`, lat: `34.5277N`, long: `117.3536W` },
  { city: `Visalia`, state: `California`, lat: `36.3272N`, long: `119.3234W` },
  { city: `West Covina`, state: `California`, lat: `34.0559N`, long: `117.9099W` },
  { city: `Arvada`, state: `Colorado`, lat: `39.8097N`, long: `105.1066W` },
  { city: `Aurora`, state: `Colorado`, lat: `32.7007N`, long: `97.1247W` },
  { city: `Boulder`, state: `Colorado`, lat: `40.0175N`, long: `105.2797W` },
  { city: `Centennial`, state: `Colorado`, lat: `39.5906N`, long: `104.8691W` },
  { city: `Colorado Springs`, state: `Colorado`, lat: `38.8673N`, long: `104.7607W` },
  { city: `Denver`, state: `Colorado`, lat: `39.7618N`, long: `104.8806W` },
  { city: `Fort Collins`, state: `Colorado`, lat: `40.5482N`, long: `105.0648W` },
  { city: `Lakewood`, state: `Colorado`, lat: `39.6989N`, long: `105.1176W` },
  { city: `Pueblo`, state: `Colorado`, lat: `38.2731N`, long: `104.6124W` },
  { city: `Thornton`, state: `Colorado`, lat: `39.9180N`, long: `104.9454W` },
  { city: `Westminster`, state: `Colorado`, lat: `39.8822N`, long: `105.0644W` },
  { city: `Bridgeport`, state: `Connecticut`, lat: `41.1874N`, long: `73.1957W` },
  { city: `Hartford`, state: `Connecticut`, lat: `41.7660N`, long: `72.6833W` },
  { city: `New Haven`, state: `Connecticut`, lat: `41.3108N`, long: `72.9250W` },
  { city: `Stamford`, state: `Connecticut`, lat: `41.0799N`, long: `73.5460W` },
  { city: `Waterbury`, state: `Connecticut`, lat: `41.5585N`, long: `73.0367W` },
  { city: `Washington`, state: `District of Columbia`, lat: `38.9041N`, long: `77.0171W` },
  { city: `Cape Coral`, state: `Florida`, lat: `26.6431N`, long: `81.9973W` },
  { city: `Clearwater`, state: `Florida`, lat: `27.9795N`, long: `82.7663W` },
  { city: `Coral Springs`, state: `Florida`, lat: `26.2708N`, long: `80.2593W` },
  { city: `Fort Lauderdale`, state: `Florida`, lat: `26.1413N`, long: `80.1439W` },
  { city: `Gainesville`, state: `Florida`, lat: `29.6788N`, long: `82.3459W` },
  { city: `Hialeah`, state: `Florida`, lat: `25.8699N`, long: `80.3029W` },
  { city: `Hollywood`, state: `Florida`, lat: `26.0311N`, long: `80.1646W` },
  { city: `Jacksonville`, state: `Florida`, lat: `30.3370N`, long: `81.6613W` },
  { city: `Miami`, state: `Florida`, lat: `25.7752N`, long: `80.2086W` },
  { city: `Miami Gardens`, state: `Florida`, lat: `25.9489N`, long: `80.2436W` },
  { city: `Miramar`, state: `Florida`, lat: `25.9770N`, long: `80.3358W` },
  { city: `Orlando`, state: `Florida`, lat: `28.4159N`, long: `81.2988W` },
  { city: `Palm Bay`, state: `Florida`, lat: `27.9856N`, long: `80.6626W` },
  { city: `Pembroke Pines`, state: `Florida`, lat: `26.0212N`, long: `80.3404W` },
  { city: `Pompano Beach`, state: `Florida`, lat: `26.2426N`, long: `80.1290W` },
  { city: `Port St. Lucie`, state: `Florida`, lat: `27.2810N`, long: `80.3838W` },
  { city: `St. Petersburg`, state: `Florida`, lat: `27.7620N`, long: `82.6441W` },
  { city: `Tallahassee`, state: `Florida`, lat: `30.4551N`, long: `84.2534W` },
  { city: `Tampa`, state: `Florida`, lat: `27.9701N`, long: `82.4797W` },
  { city: `West Palm Beach`, state: `Florida`, lat: `26.7483N`, long: `80.1266W` },
  { city: `Athens`, state: `Georgia`, lat: `33.9496N`, long: `83.3701W` },
  { city: `Atlanta`, state: `Georgia`, lat: `33.7629N`, long: `84.4227W` },
  { city: `Augusta`, state: `Georgia`, lat: `33.3655N`, long: `82.0734W` },
  { city: `Columbus`, state: `Georgia`, lat: `32.5102N`, long: `84.8749W` },
  { city: `Savannah`, state: `Georgia`, lat: `32.0025N`, long: `81.1536W` },
  { city: `Honolulu`, state: `Hawai'i`, lat: `21.3259N`, long: `157.8453W` },
  { city: `Boise`, state: `Idaho`, lat: `43.5985N`, long: `116.2311W` },
  { city: `Aurora`, state: `Illinois`, lat: `41.7635N`, long: `88.2901W` },
  { city: `Chicago`, state: `Illinois`, lat: `41.8376N`, long: `87.6818W` },
  { city: `Elgin`, state: `Illinois`, lat: `42.0396N`, long: `88.3217W` },
  { city: `Joliet`, state: `Illinois`, lat: `41.5181N`, long: `88.1584W` },
  { city: `Naperville`, state: `Illinois`, lat: `41.7492N`, long: `88.1620W` },
  { city: `Peoria`, state: `Illinois`, lat: `40.7523N`, long: `89.6171W` },
  { city: `Rockford`, state: `Illinois`, lat: `42.2634N`, long: `89.0628W` },
  { city: `Springfield`, state: `Illinois`, lat: `39.7639N`, long: `89.6708W` },
  { city: `Evansville`, state: `Indiana`, lat: `37.9877N`, long: `87.5347W` },
  { city: `Fort Wayne`, state: `Indiana`, lat: `41.0882N`, long: `85.1439W` },
  { city: `Indianapolis`, state: `Indiana`, lat: `39.7767N`, long: `86.1459W` },
  { city: `South Bend`, state: `Indiana`, lat: `41.6769N`, long: `86.2690W` },
  { city: `Cedar Rapids`, state: `Iowa`, lat: `41.9670N`, long: `91.6778W` },
  { city: `Davenport`, state: `Iowa`, lat: `41.5541N`, long: `90.6040W` },
  { city: `Des Moines`, state: `Iowa`, lat: `41.5739N`, long: `93.6167W` },
  { city: `Kansas City`, state: `Kansas`, lat: `39.1225N`, long: `94.7418W` },
  { city: `Olathe`, state: `Kansas`, lat: `38.8843N`, long: `94.8188W` },
  { city: `Overland Park`, state: `Kansas`, lat: `38.8890N`, long: `94.6906W` },
  { city: `Topeka`, state: `Kansas`, lat: `39.0362N`, long: `95.6948W` },
  { city: `Wichita`, state: `Kansas`, lat: `37.6907N`, long: `97.3427W` },
  { city: `Lexington`, state: `Kentucky`, lat: `38.0402N`, long: `84.4584W` },
  { city: `Louisville`, state: `Kentucky`, lat: `38.1781N`, long: `85.6667W` },
  { city: `Baton Rouge`, state: `Louisiana`, lat: `30.4485N`, long: `91.1259W` },
  { city: `Lafayette`, state: `Louisiana`, lat: `30.2116N`, long: `92.0314W` },
  { city: `New Orleans`, state: `Louisiana`, lat: `30.0686N`, long: `89.9390W` },
  { city: `Shreveport`, state: `Louisiana`, lat: `32.4670N`, long: `93.7927W` },
  { city: `Baltimore`, state: `Maryland`, lat: `39.3002N`, long: `76.6105W` },
  { city: `Boston`, state: `Massachusetts`, lat: `42.3320N`, long: `71.0202W` },
  { city: `Cambridge`, state: `Massachusetts`, lat: `42.3760N`, long: `71.1183W` },
  { city: `Lowell`, state: `Massachusetts`, lat: `42.6389N`, long: `71.3221W` },
  { city: `Springfield`, state: `Massachusetts`, lat: `42.1155N`, long: `72.5400W` },
  { city: `Worcester`, state: `Massachusetts`, lat: `42.2695N`, long: `71.8078W` },
  { city: `Ann Arbor`, state: `Michigan`, lat: `42.2756N`, long: `83.7313W` },
  { city: `Detroit`, state: `Michigan`, lat: `42.3830N`, long: `83.1022W` },
  { city: `Flint`, state: `Michigan`, lat: `43.0244N`, long: `83.6920W` },
  { city: `Grand Rapids`, state: `Michigan`, lat: `42.9612N`, long: `85.6556W` },
  { city: `Lansing`, state: `Michigan`, lat: `42.7098N`, long: `84.5562W` },
  { city: `Sterling Heights`, state: `Michigan`, lat: `42.5812N`, long: `83.0303W` },
  { city: `Warren`, state: `Michigan`, lat: `42.4929N`, long: `83.0250W` },
  { city: `Minneapolis`, state: `Minnesota`, lat: `44.9633N`, long: `93.2683W` },
  { city: `Rochester`, state: `Minnesota`, lat: `44.0154N`, long: `92.4772W` },
  { city: `Saint Paul`, state: `Minnesota`, lat: `44.9489N`, long: `93.1039W` },
  { city: `Jackson`, state: `Mississippi`, lat: `32.3158N`, long: `90.2128W` },
  { city: `Columbia`, state: `Missouri`, lat: `38.9479N`, long: `92.3261W` },
  { city: `Independence`, state: `Missouri`, lat: `39.0853N`, long: `94.3513W` },
  { city: `Kansas City`, state: `Missouri`, lat: `39.1252N`, long: `94.5511W` },
  { city: `Springfield`, state: `Missouri`, lat: `37.1942N`, long: `93.2913W` },
  { city: `St. Louis`, state: `Missouri`, lat: `38.6357N`, long: `90.2446W` },
  { city: `Billings`, state: `Montana`, lat: `45.7895N`, long: `108.5499W` },
  { city: `Lincoln`, state: `Nebraska`, lat: `40.8090N`, long: `96.6804W` },
  { city: `Omaha`, state: `Nebraska`, lat: `41.2647N`, long: `96.0419W` },
  { city: `Henderson`, state: `Nevada`, lat: `36.0122N`, long: `115.0375W` },
  { city: `Las Vegas`, state: `Nevada`, lat: `36.2277N`, long: `115.2640W` },
  { city: `North Las Vegas`, state: `Nevada`, lat: `36.2830N`, long: `115.0893W` },
  { city: `Reno`, state: `Nevada`, lat: `39.4745N`, long: `119.7765W` },
  { city: `Manchester`, state: `New Hampshire`, lat: `42.9847N`, long: `71.4439W` },
  { city: `Elizabeth`, state: `New Jersey`, lat: `40.6663N`, long: `74.1935W` },
  { city: `Jersey City`, state: `New Jersey`, lat: `40.7114N`, long: `74.0648W` },
  { city: `Newark`, state: `New Jersey`, lat: `40.7242N`, long: `74.1726W` },
  { city: `Paterson`, state: `New Jersey`, lat: `40.9147N`, long: `74.1628W` },
  { city: `Albuquerque`, state: `New Mexico`, lat: `35.1056N`, long: `106.6474W` },
  { city: `Las Cruces`, state: `New Mexico`, lat: `32.3197N`, long: `106.7653W` },
  { city: `Buffalo`, state: `New York`, lat: `42.8925N`, long: `78.8597W` },
  { city: `New York`, state: `New York`, lat: `40.6643N`, long: `73.9385W` },
  { city: `Rochester`, state: `New York`, lat: `43.1699N`, long: `77.6169W` },
  { city: `Syracuse`, state: `New York`, lat: `43.0410N`, long: `76.1436W` },
  { city: `Yonkers`, state: `New York`, lat: `40.9459N`, long: `73.8674W` },
  { city: `Cary`, state: `North Carolina`, lat: `35.7821N`, long: `78.8141W` },
  { city: `Charlotte`, state: `North Carolina`, lat: `35.2087N`, long: `80.8307W` },
  { city: `Durham`, state: `North Carolina`, lat: `35.9810N`, long: `78.9056W` },
  { city: `Fayetteville`, state: `North Carolina`, lat: `35.0851N`, long: `78.9803W` },
  { city: `Greensboro`, state: `North Carolina`, lat: `36.0965N`, long: `79.8271W` },
  { city: `High Point`, state: `North Carolina`, lat: `35.9855N`, long: `79.9902W` },
  { city: `Raleigh`, state: `North Carolina`, lat: `35.8302N`, long: `78.6414W` },
  { city: `Wilmington`, state: `North Carolina`, lat: `34.2092N`, long: `77.8858W` },
  { city: `Winston-Salem`, state: `North Carolina`, lat: `36.1033N`, long: `80.2606W` },
  { city: `Fargo`, state: `North Dakota`, lat: `46.8652N`, long: `96.8290W` },
  { city: `Akron`, state: `Ohio`, lat: `41.0805N`, long: `81.5214W` },
  { city: `Cincinnati`, state: `Ohio`, lat: `39.1399N`, long: `84.5064W` },
  { city: `Cleveland`, state: `Ohio`, lat: `41.4781N`, long: `81.6795W` },
  { city: `Columbus`, state: `Ohio`, lat: `39.9848N`, long: `82.9850W` },
  { city: `Dayton`, state: `Ohio`, lat: `39.7774N`, long: `84.1996W` },
  { city: `Toledo`, state: `Ohio`, lat: `41.6641N`, long: `83.5819W` },
  { city: `Broken Arrow`, state: `Oklahoma`, lat: `36.0365N`, long: `95.7810W` },
  { city: `Norman`, state: `Oklahoma`, lat: `35.2406N`, long: `97.3453W` },
  { city: `Oklahoma City`, state: `Oklahoma`, lat: `35.4671N`, long: `97.5137W` },
  { city: `Tulsa`, state: `Oklahoma`, lat: `36.1279N`, long: `95.9023W` },
  { city: `Eugene`, state: `Oregon`, lat: `44.0567N`, long: `123.1162W` },
  { city: `Gresham`, state: `Oregon`, lat: `45.5023N`, long: `122.4416W` },
  { city: `Portland`, state: `Oregon`, lat: `45.5370N`, long: `122.6500W` },
  { city: `Salem`, state: `Oregon`, lat: `44.9237N`, long: `123.0231W` },
  { city: `Allentown`, state: `Pennsylvania`, lat: `40.5940N`, long: `75.4782W` },
  { city: `Erie`, state: `Pennsylvania`, lat: `42.1166N`, long: `80.0735W` },
  { city: `Philadelphia`, state: `Pennsylvania`, lat: `40.0094N`, long: `75.1333W` },
  { city: `Pittsburgh`, state: `Pennsylvania`, lat: `40.4398N`, long: `79.9766W` },
  { city: `Providence`, state: `Rhode Island`, lat: `41.8231N`, long: `71.4188W` },
  { city: `Charleston`, state: `South Carolina`, lat: `32.8179N`, long: `79.9589W` },
  { city: `Columbia`, state: `South Carolina`, lat: `34.0298N`, long: `80.8966W` },
  { city: `North Charleston`, state: `South Carolina`, lat: `32.8853N`, long: `80.0169W` },
  { city: `Sioux Falls`, state: `South Dakota`, lat: `43.5383N`, long: `96.7320W` },
  { city: `Chattanooga`, state: `Tennessee`, lat: `35.0665N`, long: `85.2471W` },
  { city: `Clarksville`, state: `Tennessee`, lat: `36.5664N`, long: `87.3452W` },
  { city: `Knoxville`, state: `Tennessee`, lat: `35.9709N`, long: `83.9465W` },
  { city: `Memphis`, state: `Tennessee`, lat: `35.1035N`, long: `89.9785W` },
  { city: `Murfreesboro`, state: `Tennessee`, lat: `35.8522N`, long: `86.4161W` },
  { city: `Nashville`, state: `Tennessee`, lat: `36.1718N`, long: `86.7850W` },
  { city: `Abilene`, state: `Texas`, lat: `32.4545N`, long: `99.7381W` },
  { city: `Amarillo`, state: `Texas`, lat: `35.1978N`, long: `101.8287W` },
  { city: `Arlington`, state: `Texas`, lat: `32.7007N`, long: `97.1247W` },
  { city: `Austin`, state: `Texas`, lat: `30.3072N`, long: `97.7560W` },
  { city: `Beaumont`, state: `Texas`, lat: `30.0843N`, long: `94.1458W` },
  { city: `Brownsville`, state: `Texas`, lat: `26.0183N`, long: `97.4538W` },
  { city: `Carrollton`, state: `Texas`, lat: `32.9884N`, long: `96.8998W` },
  { city: `Corpus Christi`, state: `Texas`, lat: `27.7543N`, long: `97.1734W` },
  { city: `Dallas`, state: `Texas`, lat: `32.7757N`, long: `96.7967W` },
  { city: `Denton`, state: `Texas`, lat: `33.2151N`, long: `97.1417W` },
  { city: `El Paso`, state: `Texas`, lat: `31.8484N`, long: `106.4270W` },
  { city: `Fort Worth`, state: `Texas`, lat: `32.7795N`, long: `97.3463W` },
  { city: `Frisco`, state: `Texas`, lat: `33.1510N`, long: `96.8193W` },
  { city: `Garland`, state: `Texas`, lat: `32.9098N`, long: `96.6304W` },
  { city: `Grand Prairie`, state: `Texas`, lat: `32.6842N`, long: `97.0210W` },
  { city: `Houston`, state: `Texas`, lat: `29.7805N`, long: `95.3863W` },
  { city: `Irving`, state: `Texas`, lat: `32.8577N`, long: `96.9700W` },
  { city: `Killeen`, state: `Texas`, lat: `31.0777N`, long: `97.7320W` },
  { city: `Laredo`, state: `Texas`, lat: `27.5477N`, long: `99.4869W` },
  { city: `Lubbock`, state: `Texas`, lat: `33.5665N`, long: `101.8867W` },
  { city: `McAllen`, state: `Texas`, lat: `26.2185N`, long: `98.2461W` },
  { city: `McKinney`, state: `Texas`, lat: `33.2012N`, long: `96.6680W` },
  { city: `Mesquite`, state: `Texas`, lat: `32.7639N`, long: `96.5924W` },
  { city: `Midland`, state: `Texas`, lat: `32.0299N`, long: `102.1097W` },
  { city: `Odessa`, state: `Texas`, lat: `31.8804N`, long: `102.3434W` },
  { city: `Pasadena`, state: `Texas`, lat: `29.6583N`, long: `95.1505W` },
  { city: `Plano`, state: `Texas`, lat: `33.0508N`, long: `96.7479W` },
  { city: `Richardson`, state: `Texas`, lat: `32.9723N`, long: `96.7081W` },
  { city: `Round Rock`, state: `Texas`, lat: `30.5237N`, long: `97.6674W` },
  { city: `San Antonio`, state: `Texas`, lat: `29.4724N`, long: `98.5251W` },
  { city: `Waco`, state: `Texas`, lat: `31.5601N`, long: `97.1860W` },
  { city: `Wichita Falls`, state: `Texas`, lat: `33.9067N`, long: `98.5259W` },
  { city: `Provo`, state: `Utah`, lat: `40.2453N`, long: `111.6448W` },
  { city: `Salt Lake City`, state: `Utah`, lat: `40.7785N`, long: `111.9314W` },
  { city: `West Jordan`, state: `Utah`, lat: `40.6023N`, long: `112.0010W` },
  { city: `West Valley City`, state: `Utah`, lat: `40.6885N`, long: `112.0118W` },
  { city: `Alexandria`, state: `Virginia`, lat: `38.8183N`, long: `77.0820W` },
  { city: `Chesapeake`, state: `Virginia`, lat: `36.6794N`, long: `76.3018W` },
  { city: `Hampton`, state: `Virginia`, lat: `37.0480N`, long: `76.2971W` },
  { city: `Newport News`, state: `Virginia`, lat: `37.0760N`, long: `76.5217W` },
  { city: `Norfolk`, state: `Virginia`, lat: `36.9230N`, long: `76.2446W` },
  { city: `Richmond`, state: `Virginia`, lat: `37.5314N`, long: `77.4760W` },
  { city: `Virginia Beach`, state: `Virginia`, lat: `36.7793N`, long: `76.0240W` },
  { city: `Bellevue`, state: `Washington`, lat: `47.5978N`, long: `122.1565W` },
  { city: `Everett`, state: `Washington`, lat: `48.0033N`, long: `122.1742W` },
  { city: `Kent`, state: `Washington`, lat: `47.3853N`, long: `122.2169W` },
  { city: `Seattle`, state: `Washington`, lat: `47.6205N`, long: `122.3509W` },
  { city: `Spokane`, state: `Washington`, lat: `47.6736N`, long: `117.4166W` },
  { city: `Tacoma`, state: `Washington`, lat: `47.2522N`, long: `122.4598W` },
  { city: `Vancouver`, state: `Washington`, lat: `45.6372N`, long: `122.5965W` },
  { city: `Green Bay`, state: `Wisconsin`, lat: `44.5207N`, long: `87.9842W` },
  { city: `Kenosha`, state: `Wisconsin`, lat: `42.5822N`, long: `87.8456W` },
  { city: `Madison`, state: `Wisconsin`, lat: `43.0878N`, long: `89.4301W` },
  { city: `Milwaukee`, state: `Wisconsin`, lat: `43.0633N`, long: `87.9667W` },
]



// WEBPACK FOOTER //
// src/Agent/GeoLocation.js